import * as d3 from "d3";
import {colonAnnotation, numberFormat,  createAxis} from '../functions'

export default function (chart, divId, vizName, resData) {

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(response => {
        let data = resData
        // var model=d3.nest()
        //     .key(function (d){
        //         return d.dim4_name
        //     })
        //     .entries(data)
        var brand=d3.nest()
            .key(function (d){
                return d.dim3_name
            })
            .entries(data)

        // Nest the entries by symbol
        var dNest = d3.nest()
            .key(function (d) {
                return d.dim3_name;
            })
            .entries(data);

    const dim5Names = data.map(d => d.dim5_name);
    const firstDim5Name = dim5Names[0];

        dNest.forEach(function (group) {
            group.values.forEach(function (d) {
                

                let dateRegex;

                if(firstDim5Name === "YYYY-MM-DD"){
                    dateRegex = /^\d{4}-\d{2}-\d{2}$/;
                }else{
                    dateRegex = /^\d{4}-\d{2}$/;
                }

                // Check if the format is YYYY-MM (assuming it's a date)
                if (dateRegex.test(d[chart.x1DataFieldName])) {
                    d[chart.x1DataFieldName] = new Date(d[chart.x1DataFieldName]);
                    // console.log("value of d.dim", d[chart.x1DataFieldName]);
                }
                    d.metric1 = +d.metric1;
            });
        });

        let value1;
        let rang;

        switch (chart.x1D3ScaleType) {
            case "linearScale":
                value1 = [d3.min(data, d => d[chart.x1DataFieldName]), d3.max(data, d => d[chart.x1DataFieldName])];
                rang = [0, chart.width];
                break;

            case "bandScale":
                value1 = data.map(d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            case "timeScale":
                value1 = d3.extent(data, d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            default:
                // Handle any other cases or provide a default behavior
                console.error("Invalid x1D3ScaleType:", chart.x1D3ScaleType);
        }

        // console.log("value of chart.x1D3ScaleType", chart.x1D3ScaleType);

        if (value1 && rang) {

            // var value1=[d3.min(data, d => {return d.dim2_name}),d3.max(data, d => {return d.dim2_name})];
            // var rang=[0,chart.width];
            // console.log("value of chart.x1D3ScaleType", chart.x1D3ScaleType);
            var x1AxisScaleType = "timeScale";
            // console.log("value of x1Axis", x1AxisScaleType);

            var x = createAxis(chart.x1D3ScaleType).domain(value1).range(rang);
            //console.log("value of x in console",x)

            // var y = d3.scaleLinear().range([chart.height, 0]);
            // console.log('Inside mmlChart',colourscheme("d3.interpolateYlOrRd"));

            var xAxis;
            var formatTime = d3.timeFormat("%Y-%m");
            //Format d.date variable

            if(x1AxisScaleType == chart.x1D3ScaleType) {
                // Define the axes
                xAxis = d3.axisBottom(x).tickFormat(formatTime);
            }
            else
            {
                xAxis = d3.axisBottom(x);
            }
            // var yAxis = d3.axisLeft(y).tickFormat(numberFormat);


            var div = d3.select(divId)
            div.selectAll("*").remove();

            // Adds the canvas
            div = d3.select(divId).selectAll("svg")
                .data(brand)
                .enter()
                .append("svg")
                .attr("width", chart.width + chart.margin.right+chart.margin.left)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .attr("font", "Arial")
                .style("font-size", "14px")
                .append("g")
                .attr("transform",
                    "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                .attr("id", function (d) {
                    // console.log("div ", d.key);
                    return d.key;
                })

            // var lineGenerator = d3.line()
            //     .x(function(d) { return x(d[chart.x1DataFieldName]); }) // x-coordinate
            //     .y(function(d) { return y(d.metric1); }); // y-coordinate

            brand.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key
                var div = d3.select("#" + CSS.escape(d.key));

                var y = d3.scaleLinear().range([chart.height, 0]);

                y.domain([
                    (function() {
                        var minVal = d3.min(d.values, function(d) {
                            return d.metric1;
                        });
                        return (minVal < 0) ? minVal : 0;
                    })(),
                    d3.max(d.values, function(d) {
                        return d.metric1; // Maximum value in the data
                    })
                ]);

                var yAxis = d3.axisLeft(y).tickFormat(numberFormat);

                var lineGenerator = d3.line()
                    .x(function(d) { return x(d[chart.x1DataFieldName]); }) // x-coordinate
                    .y(function(d) { return y(d.metric1); }); // y-coordinate


                // Add <defs> and <clipPath> to the SVG
                div.append("defs")
                    .append("svg:clipPath")
                    .attr("id", "clip1")  // Use d.key for the clipPath id
                    .append("svg:rect")
                    .attr("x", 0)
                    .attr("y", -10)
                    .attr("width", chart.width)   // Clip width matches chart width
                    .attr("height", chart.height+10); // Clip height matches chart height

                // Append a group with clipPath applied
                const contentGroup = div.append("g")
                    .attr("class", "content")
                    .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key


                // Add the div for the tooltip
                var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);

                var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

                // Add the X Axis
                div.append("g")
                    .attr("class", "x-axis")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(xAxis)
                    .selectAll("text") //style for x axis text
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", ".15em")
                    .attr("transform", "rotate(-45)");  // Rotate the text by -45 degrees

                //adding axis labels
                div.append("text")
                    .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", "15px")
                    .style('fill', 'blue')
                    .text(chart.x1AxisDisplayName);

                // Add the Y Axis
                div.append("g").attr("class", "y-axis").call(yAxis);

                div.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("x", -40)
                    .attr("y", 65)
                    .attr("dy", "-8em")
                    .style("text-anchor", "end")
                    .attr("font-size", "15px")
                    .style('fill', 'blue')
                    // .style('display', 'none')
                    .text(chart.y1AxisDisplayName);


                div.append("g")
                    .append("text")
                    .attr("x", -40)
                    .attr("y", chart.height / 1.5)
                    .attr("dy", "-9em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "1.1em")
                    //  .style("fill",function(d) { return color(d.key) })
                    .text(function (d) {
                        return d.key
                    });
                // console.log(model);

                var dashedData = d.values.filter(function(item) {
                    return item.dim4_name === "dashed";
                });

                var dottedData = d.values.filter(function(item) {
                    return item.dim4_name === "dotted";
                });

                var simpleLine = d.values.filter(function(item) {
                    return item.dim4_name === "line";
                });



                // Append dashed line
                // Append dashed line
                contentGroup
                    .selectAll(".myline1")
                    .data([dashedData])  // Binds data to the line
                    .join("path")
                    .attr("class", "myline1")
                    .attr("fill", "none")  // No fill for the line
                    .attr("stroke", "red") // Directly specify green color
                    .attr("stroke-width", 1.5)
                    .attr("stroke-dasharray", "5,5")
                    .attr("d", lineGenerator);

                // Append dotted line
                contentGroup.selectAll(".myline2")
                    .data([dottedData])  // Binds data to the line
                    .join("path")
                    .attr("class", "myline2")
                    .attr("fill", "none")  // No fill for the line
                    .attr("stroke", "#18a5c1") // Directly specify red color
                    .attr("stroke-width", 1.5)
                    .attr("stroke-dasharray", "2,2")
                    .attr("d", lineGenerator);

                contentGroup.selectAll(".myline3")
                    .data([simpleLine])  // Binds data to the line
                    .join("path")
                    .attr("class", "myline3")
                    .attr("fill", "none")  // No fill for the line
                    .attr("stroke", "#18a5c1") // Directly specify red color
                    .attr("stroke-width", 1.5)
                    .attr("d", lineGenerator);


                // Add the dots for the tooltip
                contentGroup.selectAll(".dot")
                    .data(function (d) {
                        // console.log("d values",d.values);
                        return d.values
                    })
                    .enter().append("circle")
                    .attr("class","dot")
                    .attr("r", 5)
                    .attr("cx", function (d) {
                        return x(d[chart.x1DataFieldName]);
                    })
                    .attr("cy", function (d) {
                        return y(d.metric1);
                    })
                    .style("fill", function (d) {
                        // console.log('color',d.dim4_name)
                        return d.dim4_name == 'dotted' ? "#18a5c1" : d.dim4_name == 'dashed' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                    })
                    //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                    .on("mouseover", function (d) {
                        const fontColor = d.dim4_name == 'dotted' ? "#18a5c1" : d.dim4_name == 'dashed' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                        div1.transition()
                            .duration(200)
                            .style("opacity", .9);
                        div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                            chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                            chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                            .style("left", (d3.event.pageX) + "px")
                            .style("top", (d3.event.pageY - 28) + "px")
                            .style("color",fontColor);
                    })
                    .on("mouseout", function () {
                        div1.transition().duration(500).style("opacity", 0);
                    });


                // Add legends on the right side
                let legendLabels = {};
                try {
                    // legendMetricTooltip comes as JSON string: e.g. {"dotted":"PFY","line":"CFY"}
                    if (chart.legendMetricTooltip) {
                        legendLabels = JSON.parse(chart.legendMetricTooltip);
                    }
                } catch (e) {
                    console.error("Failed to parse legendMetricTooltip", chart.legendMetricTooltip, e);
                }

                const legendItems = [
                    { label: legendLabels.dotted || "Dotted", color: "#18a5c1", dash: "2,2" },
                    { label: legendLabels.line || "Line",   color: "#18a5c1", dash: null }
                ];

                const legend = div.append("g")
                    .attr("class", "legend")
                    // place legend to the right of plotting area
                    .attr("transform", "translate(" + (chart.width + 20) + ",20)");

                const legendRow = legend.selectAll(".legend-item")
                    .data(legendItems)
                    .enter()
                    .append("g")
                    .attr("class", "legend-item")
                    .attr("transform", function(d, i) {
                        return "translate(0," + (i * 22) + ")";
                    });

                // line symbol
                legendRow.append("line")
                    .attr("x1", 0)
                    .attr("x2", 24)
                    .attr("y1", 0)
                    .attr("y2", 0)
                    .attr("stroke-width", 2)
                    .attr("stroke", function(d) { return d.color; })
                    .attr("stroke-dasharray", function(d) { return d.dash || null; });

                // label
                legendRow.append("text")
                    .attr("x", 30)
                    .attr("y", 4)
                    .style("font-size", "12px")
                    .text(function(d) { return d.label; });


                var zoomBehaviour = d3.zoom()
                    .scaleExtent([1, 10])  // Define the zoom range (0.5x to 5x zoom)
                    .on("zoom", zoomed);  // Attach the zoom event

                // Apply zoom to the SVG
                contentGroup.insert("rect","circle")
                    .attr("width",chart.width)
                    .attr("height",chart.height)
                    .attr("fill","none")
                    .attr("pointer-events","all")
                    .call(zoomBehaviour);

                function zoomed(){
                    var zoomState = d3.zoomTransform(this);
                    // console.log(zoomState);
                    var newXScale = zoomState.rescaleX(x);
                    var newYScale = zoomState.rescaleY(y);

                    // console.log("newYscale",newYScale);
                    div.select('.y-axis').call(d3.axisLeft(newYScale).tickFormat(numberFormat));
                    div.select(".x-axis").call(d3.axisBottom(newXScale)
                        .tickFormat(formatTime)).selectAll("text") //style for x axis text
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", ".15em")
                        .attr("transform", "rotate(-45)");  // Rotate the text by -45 degrees;

                    // Update the line paths with the new x-scale and y-scale
                    contentGroup.selectAll(".myline1")
                        .attr("d", lineGenerator
                            .x((d) => newXScale(d[chart.x1DataFieldName])) // Update the x attribute
                            .y((d) => newYScale(d.metric1)) // Update the y attribute
                        );

                    contentGroup.selectAll(".myline2")
                        .attr("d", lineGenerator
                            .x((d) => newXScale(d[chart.x1DataFieldName])) // Update the x attribute
                            .y((d) => newYScale(d.metric1)) // Update the y attribute
                        );

                    contentGroup.selectAll(".myline3")
                        .attr("d", lineGenerator
                            .x((d) => newXScale(d[chart.x1DataFieldName])) // Update the x attribute
                            .y((d) => newYScale(d.metric1)) // Update the y attribute
                        );


                    // Update the circles (dots) to move accordingly
                    contentGroup.selectAll(".dot")
                        .attr("cy", function (d) {
                            return newYScale(d.metric1);
                        })
                        .attr("cx", function (d) {
                            return newXScale(d[chart.x1DataFieldName]);
                        })

                }

                /* // Add legends
                 var legend = div.append("g")
                     .attr("class", "legend")
                     .attr("transform", "translate(" + (0) + "," + 250 + ")");

                legend.selectAll("circle")
                    .data(["red", "#18a5c1"])
                    .enter()
                    .append("circle")
                    .attr("cx", function(d, i) { return i * 80; }) // Adjust the horizontal position
                    .attr("cy", 0)
                    .attr("r", 5)
                    .style("fill", function(d) { return d; });

                legend.selectAll("text")
                    .data(["Dashed", "Dotted"])
                    .enter()
                    .append("text")
                    .attr("x", function(d, i) { return 10 + i * 80; }) // Adjust the horizontal position
                    .attr("y", 6)
                    .text(function(d) { return d; });

*/
            })
        }
    // })
}
